enum EmailMetric {
  BOUNCES = "bounces",
  CLICK_RATE = "clickRate",
  EMAILS_SENT = "emailsSent",
  OPEN_RATE = "openRate",
  REPLY_RATE = "replyRate",
  UNIQUE_CONTACTS = "uniqueContacts",
}

export default EmailMetric;
